module.exports = __webpack_public_path__ + "static/media/400172_02.cd61a6e6.png";